<template>
  <div class="container">
    <div
      class="content"
      v-if="
        showHome && showBoard && showPhoneNews && showCleanGover && showTextAll
      "
    >
      <div class="top-tips">
        <div class="left">
          <img src="../../../assets/images/alarm-clock.png" alt="" />
          <span>{{ currentTime }}</span>
        </div>
        <div class="right">
          <input
            type="text"
            placeholder="请输入"
            v-model="searchValue"
            class="no-outline-input"
          />
          <div class="button" @click="istrue">
            <img src="../../../assets/images/search.png" alt="" />
          </div>
        </div>
      </div>
      <div class="content-left-top">
        <div class="swiper">
          <div
            class="carousel"
            @mouseenter="stopCarousel"
            @mouseleave="startCarousel"
          >
            <div class="carousel-image" v-if="tenList.length">
              <img
                @click="goimgInfo(tenList[currentIndex])"
                :src="tenList[currentIndex].annexUrl"
                :alt="tenList[currentIndex].id"
              />
            </div>
            <div class="indicators" v-if="tenList.length">
              <span
                v-for="(item, index) in tenList"
                :key="index"
                class="indicator"
                :class="{ active: index === currentIndex }"
                @click="currentIndex = index"
              >
                {{ index + 1 }}
              </span>
            </div>
          </div>
          <div class="title" v-if="tenList.length">
            {{ tenList[currentIndex].titleContent }}
          </div>
        </div>
        <div class="sec-right">
          <div class="sec-right-title">
            <div class="tag">
              <img src="../../../assets/images/sec-tag2.png" alt="" />
              <span>政工动态</span>
            </div>
            <div class="more-box" @click="liebiao('SuperiorSpirit')">
              <div class="more">更多 >></div>
              <!-- <div class="blue-rect"></div> -->
            </div>
          </div>
          <ul class="custom-list warp">
            <li
              v-for="(item, index) in zeroList"
              :key="item.id"
              class="custom-list-item"
            >
              <div class="li-content">
                <div class="custom-link hover-underline" @click="goInfo(item)">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="item.titleContent"
                    placement="top"
                    :open-delay="500"
                  >
                    <div>{{ item.titleContents }}</div>
                  </el-tooltip>
                </div>
                <div>[{{ item.releaseTime }}]</div>
              </div>
            </li>
          </ul>
        </div>
        <!-- <div class="content-right-top mar-bot">
          <div class="right-tab">
            <div class="right-text">{{fileTitleList[0].post}}</div>
            <div class="right-more" @click="gengduo(1,3)">更多>></div>
          </div>
          <ul class="custom-list">
            <li
              v-for="(item, index) in workInstructionsList"
              :key="index"
            >
              <div class="li-content wid">
                <div class="custom-link hover-underline" @click="download(item)">
                  {{ item.titleContent }}
                </div>
                <div>[{{ item.releaseTime }}]</div>
              </div>
            </li>
          </ul>
        </div> -->
      </div>

      <div class="content-left-sec">
        <div class="column">
          <div class="content-left-sec-left">
            <div class="sec-right-title">
              <div class="tag">
                <img src="../../../assets/images/sec-tag.png" alt="" />
                <span>上级文件</span>
              </div>
              <div class="more-box" @click="liebiao('Notice')">
                <div class="more">更多 >></div>
                <!-- <div class="blue-rect"></div> -->
              </div>
            </div>
            <ul class="custom-list warp2">
              <li
                v-for="(item, index) in oneList"
                :key="index"
                class="custom-list-item"
              >
                <div class="li-content">
                  <div
                    class="custom-link hover-underline"
                    @click="goInfo(item)"
                  >
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.titleContent"
                      placement="top"
                      :open-delay="500"
                    >
                      <div>{{ item.titleContents }}</div>
                    </el-tooltip>
                  </div>
                  <div>[{{ item.releaseTime }}]</div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- <div class="content-left-sec-left" style="margin-left: 12px">
          <div class="sec-right-title">
            <div class="tag">
              <img src="../../../assets/images/sec-tag.png" alt="" />
              <span>信息动态</span>
            </div>
            <div class="more-box" @click="gengduo(3)">
              <div class="more">更多 >></div>
            </div>
          </div>
          <ul class="custom-list">
            <li
              @click="goInfo(item)"
              v-for="(item, index) in fourList"
              :key="index"
            >
              <div class="li-content">
                <div class="custom-link hover-underline">
                  {{ item.titleContent }}
                </div>
                <div>
                  <span v-if="item.isTop==1">置顶 </span> [{{ item.releaseTime }}]
                </div>
              </div>
            </li>
          </ul>
        </div> -->
        <!-- 简报专刊 -->
        <div class="content-right-sec mar-bot" style="margin-left: 12px">
          <div class="right-tab">
            <div class="right-text">通知通报</div>
            <div class="right-more" @click="liebiao('Information')">
              更多 >>
            </div>
          </div>
          <ul class="custom-list">
            <li v-for="(item, index) in twoList" :key="index">
              <div class="li-content wid">
                <div
                  class="custom-link hover-underline"
                  @click="download(item)"
                >
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="item.titleContent"
                    placement="top"
                    :open-delay="500"
                  >
                    <div>{{ item.titleContents }}</div>
                  </el-tooltip>
                </div>
                <!-- <div>[{{ item.releaseTime }}]</div> -->
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!-- 典型风采 -->
      <div class="banner hover-underline" @click="liebiao('TypicalStyle')">
        <div class="left-text">典型风采</div>
        <div class="banner-image">
          <img src="../../../assets/images/banner2.png" alt="" />
        </div>
      </div>
      <!-- 分类 -->
      <div class="sort">
        <div class="political-education">
          <div class="sec-right-title">
            <div class="tag">
              <img src="../../../assets/images/newz.png" alt="" />
              <span>政治教育</span>
            </div>
            <div class="more-box">
              <div class="more" @click="liebiao('BriefingIssue')">更多 >></div>
            </div>
          </div>
          <div class="small-title">
            <p
              :class="['hover-underline', threeIndex == 0 ? 'actColor' : '']"
              @click="check1(0)"
            >
              教育计划
            </p>
            <p>•</p>
            <p
              :class="['hover-underline', threeIndex == 1 ? 'actColor' : '']"
              @click="check1(1)"
            >
              课件教案
            </p>
            <p>•</p>
            <p
              :class="['hover-underline', threeIndex == 2 ? 'actColor' : '']"
              @click="check1(2)"
            >
              其他工作
            </p>
          </div>
          <ul
            class="custom-list"
            style="line-height: 28px"
            v-if="threeIndex == 0"
          >
            <li
              v-for="(item, index) in threeList"
              :key="index"
              @click="goInfo(item)"
              class="custom-list-item"
            >
              <div class="li-content">
                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                  "
                >
                  <div
                    class="custom-link hover-underline"
                    style="display: flex"
                  >
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.titleContent"
                      placement="top"
                      :open-delay="500"
                    >
                      <div>{{ item.titleContents }}</div>
                    </el-tooltip>
                  </div>
                  <div>[{{ item.releaseTime }}]</div>
                </div>
              </div>
            </li>
          </ul>
          <ul
            class="custom-list"
            style="line-height: 28px"
            v-if="threeIndex == 1"
          >
            <li
              v-for="(item, index) in threeList1"
              :key="index"
              @click="goInfo(item)"
              class="custom-list-item"
            >
              <div class="li-content">
                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                  "
                >
                  <div
                    class="custom-link hover-underline"
                    style="display: flex"
                  >
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.titleContent"
                      placement="top"
                      :open-delay="500"
                    >
                      <div>{{ item.titleContents }}</div>
                    </el-tooltip>
                  </div>
                  <div>[{{ item.releaseTime }}]</div>
                </div>
              </div>
            </li>
          </ul>
          <ul
            class="custom-list"
            style="line-height: 28px"
            v-if="threeIndex == 2"
          >
            <li
              v-for="(item, index) in threeList2"
              :key="index"
              @click="goInfo(item)"
              class="custom-list-item"
            >
              <div class="li-content">
                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                  "
                >
                  <div
                    class="custom-link hover-underline"
                    style="display: flex"
                    @click="goInfo(item)"
                  >
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.titleContent"
                      placement="top"
                      :open-delay="500"
                    >
                      <div>{{ item.titleContents }}</div>
                    </el-tooltip>
                  </div>
                  <div>[{{ item.releaseTime }}]</div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="political-education">
          <div class="sec-right-title">
            <div class="tag">
              <img src="../../../assets/images/newz.png" alt="" />
              <span>组织建设</span>
            </div>
            <div class="more-box">
              <div class="more" @click="liebiao('Model')">更多 >></div>
            </div>
          </div>
          <div class="small-title">
            <p
              :class="['hover-underline', fourIndex == 0 ? 'actColor' : '']"
              @click="check2(0)"
            >
              第一议题
            </p>
            <p>•</p>
            <p
              :class="['hover-underline', fourIndex == 1 ? 'actColor' : '']"
              @click="check2(1)"
            >
              党务公开
            </p>
            <p>•</p>
            <p
              :class="['hover-underline', fourIndex == 2 ? 'actColor' : '']"
              @click="check2(2)"
            >
              其他工作
            </p>
          </div>
          <ul class="custom-list" v-if="fourIndex == 0">
            <li
              v-for="(item, index) in fourList"
              :key="index"
              @click="goInfo(item)"
            >
              <div class="li-content">
                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                  "
                >
                  <div
                    class="custom-link hover-underline"
                    style="display: flex"
                  >
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.titleContent"
                      placement="top"
                      :open-delay="500"
                    >
                      <div>{{ item.titleContents }}</div>
                    </el-tooltip>
                    <div v-if="newsDate == item.releaseTime">
                      <img
                        style="width: 32px; height: 14px"
                        src="../../../assets/images/news.gif"
                        alt=""
                      />
                    </div>
                  </div>
                  <div>[{{ item.releaseTime }}]</div>
                </div>
              </div>
            </li>
          </ul>
          <ul class="custom-list" v-if="fourIndex == 1">
            <li
              v-for="(item, index) in fourList1"
              :key="index"
              @click="goInfo(item)"
            >
              <div class="li-content">
                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                  "
                >
                  <div
                    class="custom-link hover-underline"
                    style="display: flex"
                  >
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.titleContent"
                      placement="top"
                      :open-delay="500"
                    >
                      <div>{{ item.titleContents }}</div>
                    </el-tooltip>
                    <div v-if="newsDate == item.releaseTime">
                      <img
                        style="width: 32px; height: 14px"
                        src="../../../assets/images/news.gif"
                        alt=""
                      />
                    </div>
                  </div>
                  <div>[{{ item.releaseTime }}]</div>
                </div>
              </div>
            </li>
          </ul>
          <ul class="custom-list" v-if="fourIndex == 2">
            <li
              v-for="(item, index) in fourList2"
              :key="index"
              @click="goInfo(item)"
            >
              <div class="li-content">
                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                  "
                >
                  <div
                    class="custom-link hover-underline"
                    style="display: flex"
                  >
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.titleContent"
                      placement="top"
                      :open-delay="500"
                    >
                      <div>{{ item.titleContents }}</div>
                    </el-tooltip>
                    <div v-if="newsDate == item.releaseTime">
                      <img
                        style="width: 32px; height: 14px"
                        src="../../../assets/images/news.gif"
                        alt=""
                      />
                    </div>
                  </div>
                  <div>[{{ item.releaseTime }}]</div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="political-education">
          <div class="sec-right-title">
            <div class="tag">
              <img src="../../../assets/images/newz.png" alt="" />
              <span>干部人事</span>
            </div>
            <div class="more-box">
              <div class="more" @click="liebiao('PartyHistory')">更多 >></div>
            </div>
          </div>
          <div class="small-title">
            <p
              :class="['hover-underline', fiveIndex == 0 ? 'actColor' : '']"
              @click="check3(0)"
            >
              任职命令
            </p>
            <p>•</p>
            <p
              :class="['hover-underline', fiveIndex == 1 ? 'actColor' : '']"
              @click="check3(1)"
            >
              探亲休假
            </p>
            <p>•</p>
            <p
              :class="['hover-underline', fiveIndex == 2 ? 'actColor' : '']"
              @click="check3(2)"
            >
              其他工作
            </p>
          </div>
          <ul class="custom-list" v-if="fiveIndex == 0">
            <li
              v-for="(item, index) in fiveList"
              :key="index"
              @click="goInfo(item)"
            >
              <div class="li-content">
                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                  "
                >
                  <div
                    class="custom-link hover-underline"
                    style="display: flex"
                  >
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.titleContent"
                      placement="top"
                      :open-delay="500"
                    >
                      <div>{{ item.titleContents }}</div>
                    </el-tooltip>
                    <div v-if="newsDate == item.releaseTime">
                      <img
                        style="width: 32px; height: 14px"
                        src="../../../assets/images/news.gif"
                        alt=""
                      />
                    </div>
                  </div>
                  <div>[{{ item.releaseTime }}]</div>
                </div>
              </div>
            </li>
          </ul>
          <ul class="custom-list" v-if="fiveIndex == 1">
            <li
              v-for="(item, index) in fiveList1"
              :key="index"
              @click="goInfo(item)"
            >
              <div class="li-content">
                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                  "
                >
                  <div
                    class="custom-link hover-underline"
                    style="display: flex"
                  >
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.titleContent"
                      placement="top"
                      :open-delay="500"
                    >
                      <div>{{ item.titleContents }}</div>
                    </el-tooltip>
                    <div v-if="newsDate == item.releaseTime">
                      <img
                        style="width: 32px; height: 14px"
                        src="../../../assets/images/news.gif"
                        alt=""
                      />
                    </div>
                  </div>
                  <div>[{{ item.releaseTime }}]</div>
                </div>
              </div>
            </li>
          </ul>
          <ul class="custom-list" v-if="fiveIndex == 2">
            <li
              v-for="(item, index) in fiveList2"
              :key="index"
              @click="goInfo(item)"
            >
              <div class="li-content">
                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                  "
                >
                  <div
                    class="custom-link hover-underline"
                    style="display: flex"
                  >
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.titleContent"
                      placement="top"
                      :open-delay="500"
                    >
                      <div>{{ item.titleContents }}</div>
                    </el-tooltip>
                    <div v-if="newsDate == item.releaseTime">
                      <img
                        style="width: 32px; height: 14px"
                        src="../../../assets/images/news.gif"
                        alt=""
                      />
                    </div>
                  </div>
                  <div>[{{ item.releaseTime }}]</div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="political-education">
          <div class="sec-right-title">
            <div class="tag">
              <img src="../../../assets/images/newz.png" alt="" />
              <span>队伍管理</span>
            </div>
            <div class="more-box">
              <div class="more" @click="liebiao('Recommended')">更多 >></div>
            </div>
          </div>
          <div class="small-title">
            <p
              :class="['hover-underline', sixIndex == 0 ? 'actColor' : '']"
              @click="check4(0)"
            >
              任职命令
            </p>
            <p>•</p>
            <p
              :class="['hover-underline', sixIndex == 1 ? 'actColor' : '']"
              @click="check4(1)"
            >
              探亲休假
            </p>
            <p>•</p>
            <p
              :class="['hover-underline', sixIndex == 2 ? 'actColor' : '']"
              @click="check4(2)"
            >
              其他工作
            </p>
          </div>
          <ul class="custom-list" v-if="sixIndex == 0">
            <li
              v-for="(item, index) in sixList"
              :key="index"
              @click="goInfo(item)"
            >
              <div class="li-content">
                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                  "
                >
                  <div
                    class="custom-link hover-underline"
                    style="display: flex"
                  >
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.titleContent"
                      placement="top"
                      :open-delay="500"
                    >
                      <div>{{ item.titleContents }}</div>
                    </el-tooltip>
                    <div v-if="newsDate == item.releaseTime">
                      <img
                        style="width: 32px; height: 14px"
                        src="../../../assets/images/news.gif"
                        alt=""
                      />
                    </div>
                  </div>
                  <div>[{{ item.releaseTime }}]</div>
                </div>
              </div>
            </li>
          </ul>
          <ul class="custom-list" v-if="sixIndex == 1">
            <li
              v-for="(item, index) in sixList1"
              :key="index"
              @click="goInfo(item)"
            >
              <div class="li-content">
                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                  "
                >
                  <div
                    class="custom-link hover-underline"
                    style="display: flex"
                  >
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.titleContent"
                      placement="top"
                      :open-delay="500"
                    >
                      <div>{{ item.titleContents }}</div>
                    </el-tooltip>
                    <div v-if="newsDate == item.releaseTime">
                      <img
                        style="width: 32px; height: 14px"
                        src="../../../assets/images/news.gif"
                        alt=""
                      />
                    </div>
                  </div>
                  <div>[{{ item.releaseTime }}]</div>
                </div>
              </div>
            </li>
          </ul>
          <ul class="custom-list" v-if="sixIndex == 2">
            <li
              v-for="(item, index) in sixList2"
              :key="index"
              @click="goInfo(item)"
            >
              <div class="li-content">
                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                  "
                >
                  <div
                    class="custom-link hover-underline"
                    style="display: flex"
                  >
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.titleContent"
                      placement="top"
                      :open-delay="500"
                    >
                      <div>{{ item.titleContents }}</div>
                    </el-tooltip>
                    <div v-if="newsDate == item.releaseTime">
                      <img
                        style="width: 32px; height: 14px"
                        src="../../../assets/images/news.gif"
                        alt=""
                      />
                    </div>
                  </div>
                  <div>[{{ item.releaseTime }}]</div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="political-education">
          <div class="sec-right-title">
            <div class="tag">
              <img src="../../../assets/images/newz.png" alt="" />
              <span>政策规定</span>
            </div>
            <div class="more-box">
              <div class="more" @click="liebiao('PoliticalRegulations')">
                更多 >>
              </div>
            </div>
          </div>
          <ul class="custom-list">
            <li
              v-for="(item, index) in sevenList"
              :key="index"
              @click="goInfo(item)"
            >
              <div class="li-content">
                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                  "
                >
                  <div
                    class="custom-link hover-underline"
                    style="display: flex"
                  >
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.titleContent"
                      placement="top"
                      :open-delay="500"
                    >
                      <div>{{ item.titleContents }}</div>
                    </el-tooltip>
                    <div v-if="newsDate == item.releaseTime">
                      <img
                        style="width: 32px; height: 14px"
                        src="../../../assets/images/news.gif"
                        alt=""
                      />
                    </div>
                  </div>
                  <div>[{{ item.releaseTime }}]</div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="political-education">
          <div class="sec-right-title">
            <div class="tag">
              <img src="../../../assets/images/newz.png" alt="" />
              <span>政工研讨</span>
            </div>
            <div class="more-box">
              <div class="more" @click="liebiao('PoliticalWork')">更多 >></div>
            </div>
          </div>
          <ul class="custom-list">
            <li
              v-for="(item, index) in eightList"
              :key="index"
              @click="goInfo(item)"
            >
              <div class="li-content">
                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                  "
                >
                  <div
                    class="custom-link hover-underline"
                    style="display: flex"
                  >
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.titleContent"
                      placement="top"
                      :open-delay="500"
                    >
                      <div>{{ item.titleContents }}</div>
                    </el-tooltip>
                    <div v-if="newsDate == item.releaseTime">
                      <img
                        style="width: 32px; height: 14px"
                        src="../../../assets/images/news.gif"
                        alt=""
                      />
                    </div>
                  </div>
                  <div>[{{ item.releaseTime }}]</div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <!-- 底端 -->
      <div></div>
    </div>
    <div
      v-if="showPopup"
      class="popup-box"
      @mouseover="showPopupTag = true"
      @mouseleave="show1"
    >
      <ul>
        <li class="li" v-for="(item, index) in popupList" :key="index">
          <span class="hover-underline" @click="gowaizhan(item.url)">{{
            item.name
          }}</span>
        </li>
      </ul>
    </div>
    <div class="linkage">
      <div class="linkage-left">
        <div class="linkage-box">
          <img src="../../../assets/images/arrow.png" alt="" />
          <div
            class="linkage-text hover-underline"
            @click="gowaizhan('http://59.255.109.9/')"
          >
            国家消防救援局
          </div>
        </div>
        <div class="linkage-box">
          <img src="../../../assets/images/arrow.png" alt="" />
          <div
            class="linkage-text hover-underline"
            @click="gowaizhan('http://59.203.26.16/index.html')"
          >
            安徽省消防救援总队
          </div>
        </div>
        <div
          class="linkage-box"
          @mouseover="showPopup = true"
          @mouseleave="unShowPopup"
        >
          <img src="../../../assets/images/arrow.png" alt="" />
          <div class="linkage-text">本省支队网</div>
        </div>
      </div>
      <!--  -->
    </div>
  </div>
</template>

<script>
import ImportantNews from "./compotents/ImportantNews.vue";
import PhotoNews from "./compotents/PhotoNews.vue";
import CleanGover from "./compotents/CleanGover.vue";
import TextAll from "./compotents/TextAll.vue";
import { listspecial, dutyList } from "@/api/SpecialWork";
export default {
  components: {
    ImportantNews,
    PhotoNews,
    CleanGover,
    TextAll,
  },
  data() {
    return {
      threeIndex: 0,
      fourIndex: 0,
      fiveIndex: 0,
      sixIndex: 0,
      elevenShow: true,
      showPopup: false,
      showPopupTag: false,
      showHome: true,
      currentPage: "",
      searchValue: "",
      showBoard: true,
      showPhoneNews: true,
      showCleanGover: true,
      showTextAll: true,
      eletype: 0,
      date: "",
      title: "",
      currentIndex: 0,
      interval: null,
      isShowImg: false,

      images: [],
      search: "",
      serachFrom: {
        pageNum: 1,
        pageSize: 30,
      },
      swriperList: [],
      tableList: [],
      workDynamicsList: [],
      specialIssueNewsletterList: [],
      discussionExchangeList: [],
      workInstructionsList: [],
      learningCornerList: [],
      imgList: [],
      LinkList: [],
      ids: "",
      imgid: "",
      workId: "",
      winTitle: "",
      encolumnType: "",
      entype: "",
      zeroList: [],
      oneList: [],
      twoList: [],
      threeList: [],
      threeList1: [],
      threeList2: [],
      fourList: [],
      fourList1: [],
      fourList2: [],
      fiveList: [],
      fiveList1: [],
      fiveList2: [],
      sixList: [],
      sixList1: [],
      sixList2: [],
      sevenList: [],
      eightList: [],
      nineList: [],
      tenList: [],
      popupList: [
        { name: "合肥支队网", url: "http://59.203.34.139/" },
        { name: "芜湖支队网", url: "http://59.203.151.155/" },
        { name: "安庆支队网", url: "http://59.203.218.38/" },
        { name: "六安支队网", url: "http://59.203.228.64/" },
        { name: "宿州支队网", url: "https://59.203.70.7/" },
        { name: "宣城支队网", url: "http://59.203.169.55/" },
        { name: "滁州支队网", url: "http://59.203.54.56/" },
        { name: "亳州支队网", url: "http://59.203.98.80/" },
        { name: "铜陵支队网", url: "http://59.203.209.183/" },
        { name: "黄山支队网", url: "http://59.209.86.181/" },
        { name: "蚌埠支队网", url: "http://59.203.63.45/" },
        { name: "马鞍山支队网", url: "http://59.203.247.200/" },
        { name: "淮南支队网", url: "http://59.203.118.200/" },
        { name: "阜阳支队网", url: "http://59.203.106.65/" },
        { name: "池州支队网", url: "http://59.203.187.199/" },
        { name: "淮北支队网", url: "http://59.203.82.45/index.html" },
        { name: "总队训保支队网", url: "http://59.203.26.16:8089/" },
      ],
      currentTime: '',
    };
  },
  created() {
    if (this.$route.query.param) {
      this.workId = JSON.parse(this.$route.query.param);
    }
    if (this.$route.query.columnType && this.$route.query.type) {
      this.showHome = !this.showHome;
      this.encolumnType = this.$route.query.columnType;
      this.entype = this.$route.query.type;
    }
    this.getlistspecial();
  },
  mounted() {
    const params = new URLSearchParams(window.location.search);
    this.ids = params.get("ids");
    this.imgid = params.get("imgid");
    if (params.get("winTitle")) {
      this.winTitle = params.get("winTitle");
    }

    if (this.ids) {
      console.log(this.winTitle, "this.winTitle");

      this.showTextAll = !this.showTextAll;
    }
    if (this.imgid) {
      this.showCleanGover = !this.showCleanGover;
    }
    this.getDate();
    this.startCarousel();
    this.updateTime(); // 初始加载时更新一次
    this.startTimer();  // 开始每分钟更新时间
  },
  methods: {
    updateTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth() + 1; // 月份从0开始
      const day = now.getDate();
      const hours = now.getHours();
      const minutes = now.getMinutes().toString().padStart(2, '0');
      const weekDay = now.toLocaleString('zh-CN', { weekday: 'long' }); // 获取星期几

      this.currentTime = `今天是：${year}年${month}月${day}日 ${hours}:${minutes} ${weekDay}`;
    },

    // 设置每分钟更新一次
    startTimer() {
      setInterval(() => {
        this.updateTime();
      }, 60000); // 每60秒更新时间
    },
    istrue() {
      const searchValue = this.searchValue;
      const url = `/specialWork?searchValue=${searchValue}&param=${this.workId}`;
      window.open(url, "_blank");
    },
    // 点击专项工作去二级页面
    goToSec(index) {
      const url = new URL("./specialWork", window.location.origin);
      url.searchParams.append("param", index.id); // 添加查询参数
      window.open(url.toString(), "_blank");
    },
    check1(id) {
      this.threeIndex = id;
    },
    check2(id) {
      this.fourIndex = id;
    },
    check3(id) {
      this.fiveIndex = id;
    },
    check4(id) {
      this.sixIndex = id;
    },
    show1() {
      this.showPopup = false;
      this.showPopupTag = false;
    },
    unShowPopup() {
      setTimeout(() => {
        if (!this.showPopupTag) {
          this.showPopup = false;
          // this.this.showPopupTag = false
        }
      }, 500);
    },
    async dutyList(type) {
      const query = {
        pageNum: 1,
        pageSize: 10,
        type: type,
      };
      const res = await dutyList(query);
      if (res.data.code == 200) {
        if (type % 2 == 0) {
          this.essayTitleList = res.data.data.list;
          console.log(this.essayTitleList, "this.essayTitleList");
        } else {
          this.fileTitleList = res.data.data.list;
          console.log(this.fileTitleList, "this.fileTitleList");
        }
      }
    },
    download(item) {
      window.open(item.fileUrl, "_blank");
    },
    gowaizhan(url) {
      if (url == "/") {
        url = "/?showBoard=false";
      }
      window.open(url, "_blank");
    },
    goInfo(item) {
      // if (item.fileUrl) {
      //   var a = document.createElement("a");
      //   a.href = item.fileUrl;
      //   a.download = "";
      //   a.click();
      // }
      let url = ``;
      if (item.fileUrl) {
        url = item.fileUrl;
      }
      window.open(url, "_blank");
    },
    goimgInfo(item) {
      // 使用window.open方法在新窗口或选项卡中打开链接
      const ids = item.id;
      const url = `/specialWork?ider=${encodeURIComponent(ids)}&param=${
        this.workId
      }`;
      window.open(url, "_blank");
    },
    getlistspecial() {
      this.serachFrom.status = 4;
      this.serachFrom.workId = this.workId;
      listspecial({ status: 4, pageNum: 1, pageSize: 10, types: 0 }).then(
        (res) => {
          this.zeroList = res.data.data.list;
          this.zeroList.map((item) => {
            if (item.releaseTime) {
              item.releaseTime = item.releaseTime.slice(5, 10);
            }
            if (item.titleContent) {
              if (item.titleContent.length > 30) {
                item.titleContents = item.titleContent.slice(0, 30) + "...";
              } else {
                item.titleContents = item.titleContent;
              }
            }
          });
        }
      );
      listspecial({ status: 4, pageNum: 1, pageSize: 10, types: 1 }).then(
        (res) => {
          this.oneList = res.data.data.list;
          this.oneList.map((item) => {
            if (item.releaseTime) {
              item.releaseTime = item.releaseTime.slice(5, 10);
            }
            if (item.titleContent) {
              if (item.titleContent.length > 35) {
                item.titleContents = item.titleContent.slice(0, 35) + "...";
              } else {
                item.titleContents = item.titleContent;
              }
            }
          });
        }
      );
      listspecial({ status: 4, pageNum: 1, pageSize: 10, types: 2 }).then(
        (res) => {
          this.twoList = res.data.data.list;
          this.twoList.map((item) => {
            if (item.releaseTime) {
              item.releaseTime = item.releaseTime.slice(5, 10);
            }
            if (item.titleContent) {
              if (item.titleContent.length > 9) {
                item.titleContents = item.titleContent.slice(0, 9) + "...";
              } else {
                item.titleContents = item.titleContent;
              }
            }
          });
        }
      );
      listspecial({
        status: 4,
        pageNum: 1,
        pageSize: 10,
        types: 3,
        type: 0,
      }).then((res) => {
        this.threeList = res.data.data.list;
        this.threeList.map((item) => {
          if (item.releaseTime) {
            item.releaseTime = item.releaseTime.slice(5, 10);
          }
          if (item.titleContent) {
            if (item.titleContent.length > 28) {
              item.titleContents = item.titleContent.slice(0, 28) + "...";
            } else {
              item.titleContents = item.titleContent;
            }
          }
        });
      });
      listspecial({
        status: 4,
        pageNum: 1,
        pageSize: 10,
        types: 3,
        type: 1,
      }).then((res) => {
        this.threeList1 = res.data.data.list;
        this.threeList1.map((item) => {
          if (item.releaseTime) {
            item.releaseTime = item.releaseTime.slice(5, 10);
          }
          if (item.titleContent) {
            if (item.titleContent.length > 28) {
              item.titleContents = item.titleContent.slice(0, 28) + "...";
            } else {
              item.titleContents = item.titleContent;
            }
          }
        });
      });
      listspecial({
        status: 4,
        pageNum: 1,
        pageSize: 10,
        types: 3,
        type: 2,
      }).then((res) => {
        this.threeList2 = res.data.data.list;
        this.threeList2.map((item) => {
          if (item.releaseTime) {
            item.releaseTime = item.releaseTime.slice(5, 10);
          }
          if (item.titleContent) {
            if (item.titleContent.length > 28) {
              item.titleContents = item.titleContent.slice(0, 28) + "...";
            } else {
              item.titleContents = item.titleContent;
            }
          }
        });
      });
      listspecial({
        status: 4,
        pageNum: 1,
        pageSize: 10,
        types: 4,
        type: 0,
      }).then((res) => {
        this.fourList = res.data.data.list;
        this.fourList.map((item) => {
          if (item.releaseTime) {
            item.releaseTime = item.releaseTime.slice(5, 10);
          }
          if (item.titleContent) {
            if (item.titleContent.length > 28) {
              item.titleContents = item.titleContent.slice(0, 28) + "...";
            } else {
              item.titleContents = item.titleContent;
            }
          }
        });
      });
      listspecial({
        status: 4,
        pageNum: 1,
        pageSize: 10,
        types: 4,
        type: 1,
      }).then((res) => {
        this.fourList1 = res.data.data.list;
        this.fourList1.map((item) => {
          if (item.releaseTime) {
            item.releaseTime = item.releaseTime.slice(5, 10);
          }
          if (item.titleContent) {
            if (item.titleContent.length > 28) {
              item.titleContents = item.titleContent.slice(0, 28) + "...";
            } else {
              item.titleContents = item.titleContent;
            }
          }
        });
      });
      listspecial({
        status: 4,
        pageNum: 1,
        pageSize: 10,
        types: 4,
        type: 2,
      }).then((res) => {
        this.fourList2 = res.data.data.list;
        this.fourList2.map((item) => {
          if (item.releaseTime) {
            item.releaseTime = item.releaseTime.slice(5, 10);
          }
          if (item.titleContent) {
            if (item.titleContent.length > 28) {
              item.titleContents = item.titleContent.slice(0, 28) + "...";
            } else {
              item.titleContents = item.titleContent;
            }
          }
        });
      });
      listspecial({
        status: 4,
        pageNum: 1,
        pageSize: 10,
        types: 5,
        type: 0,
      }).then((res) => {
        this.fiveList = res.data.data.list;
        this.fiveList.map((item) => {
          if (item.releaseTime) {
            item.releaseTime = item.releaseTime.slice(5, 10);
          }
          if (item.titleContent) {
            if (item.titleContent.length > 28) {
              item.titleContents = item.titleContent.slice(0, 28) + "...";
            } else {
              item.titleContents = item.titleContent;
            }
          }
        });
      });
      listspecial({
        status: 4,
        pageNum: 1,
        pageSize: 10,
        types: 5,
        type: 1,
      }).then((res) => {
        this.fiveList1 = res.data.data.list;
        this.fiveList1.map((item) => {
          if (item.releaseTime) {
            item.releaseTime = item.releaseTime.slice(5, 10);
          }
          if (item.titleContent) {
            if (item.titleContent.length > 28) {
              item.titleContents = item.titleContent.slice(0, 28) + "...";
            } else {
              item.titleContents = item.titleContent;
            }
          }
        });
      });
      listspecial({
        status: 4,
        pageNum: 1,
        pageSize: 10,
        types: 5,
        type: 2,
      }).then((res) => {
        this.fiveList2 = res.data.data.list;
        this.fiveList2.map((item) => {
          if (item.releaseTime) {
            item.releaseTime = item.releaseTime.slice(5, 10);
          }
          if (item.titleContent) {
            if (item.titleContent.length > 28) {
              item.titleContents = item.titleContent.slice(0, 28) + "...";
            } else {
              item.titleContents = item.titleContent;
            }
          }
        });
      });
      listspecial({
        status: 4,
        pageNum: 1,
        pageSize: 10,
        types: 6,
        type: 0,
      }).then((res) => {
        this.sixList = res.data.data.list;
        this.sixList.map((item) => {
          if (item.releaseTime) {
            item.releaseTime = item.releaseTime.slice(5, 10);
          }
          if (item.titleContent) {
            if (item.titleContent.length > 28) {
              item.titleContents = item.titleContent.slice(0, 28) + "...";
            } else {
              item.titleContents = item.titleContent;
            }
          }
        });
      });
      listspecial({
        status: 4,
        pageNum: 1,
        pageSize: 10,
        types: 6,
        type: 1,
      }).then((res) => {
        this.sixList1 = res.data.data.list;
        this.sixList1.map((item) => {
          if (item.releaseTime) {
            item.releaseTime = item.releaseTime.slice(5, 10);
          }
          if (item.titleContent) {
            if (item.titleContent.length > 28) {
              item.titleContents = item.titleContent.slice(0, 28) + "...";
            } else {
              item.titleContents = item.titleContent;
            }
          }
        });
      });
      listspecial({
        status: 4,
        pageNum: 1,
        pageSize: 10,
        types: 6,
        type: 2,
      }).then((res) => {
        this.sixList2 = res.data.data.list;
        this.sixList2.map((item) => {
          if (item.releaseTime) {
            item.releaseTime = item.releaseTime.slice(5, 10);
          }
          if (item.titleContent) {
            if (item.titleContent.length > 28) {
              item.titleContents = item.titleContent.slice(0, 28) + "...";
            } else {
              item.titleContents = item.titleContent;
            }
          }
        });
      });
      listspecial({ status: 4, pageNum: 1, pageSize: 10, types: 7 }).then(
        (res) => {
          this.sevenList = res.data.data.list;
          this.sevenList.map((item) => {
            if (item.releaseTime) {
              item.releaseTime = item.releaseTime.slice(5, 10);
            }
            if (item.titleContent) {
              if (item.titleContent.length > 28) {
                item.titleContents = item.titleContent.slice(0, 28) + "...";
              } else {
                item.titleContents = item.titleContent;
              }
            }
          });
        }
      );
      listspecial({ status: 4, pageNum: 1, pageSize: 10, types: 8 }).then(
        (res) => {
          this.eightList = res.data.data.list;
          this.eightList.map((item) => {
            if (item.releaseTime) {
              item.releaseTime = item.releaseTime.slice(5, 10);
            }
            if (item.titleContent) {
              if (item.titleContent.length > 28) {
                item.titleContents = item.titleContent.slice(0, 28) + "...";
              } else {
                item.titleContents = item.titleContent;
              }
            }
          });
        }
      );
      listspecial({ status: 4, pageNum: 1, pageSize: 5, types: 10 }).then(
        (res) => {
          this.tenList = res.data.data.list;
          this.tenList.map((item) => {
            if (item.releaseTime) {
              item.releaseTime = item.releaseTime.slice(5, 10);
            }
            if (item.titleContent) {
              if (item.titleContent.length > 28) {
                item.titleContents = item.titleContent.slice(0, 28) + "...";
              } else {
                item.titleContents = item.titleContent;
              }
            }
          });
        }
      );
    },
    bannerBtn() {
      this.bannerobj = this.tenList[this.currentIndex];
      this.showCleanGover = !this.showCleanGover;
    },
    swriperBtn(item) {
      this.showCleanGover = !this.showCleanGover;
      this.bannerobj = item;
    },
    textBtn(item) {
      this.textobj = item;
      this.showTextAll = !this.showTextAll;
    },
    setShow(value) {
      this.showHome = value;
      this.showBoard = value;
      this.showPhoneNews = value;
      this.showCleanGover = value;
      this.showTextAll = value;
    },
    liebiao(names) {
      this.$emit("changeYm", names);
    },
    gengduo(columnType, type) {
      const url = `/specialWork?columnType=${encodeURIComponent(
        columnType
      )}&type=${encodeURIComponent(type)}&param=${encodeURIComponent(
        this.workId
      )}`;
      window.open(url, "_blank");
      // this.showHome = !this.showHome;
      // this.encolumnType = columnType;
      // this.entype = type;
    },

    getDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = today.getMonth() + 1;
      const date = today.getDate();
      const weekday = today.getDay();
      const weekdays = [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ];
      const weekdayName = weekdays[weekday];
      console.log(`今天是${year}年${month}月${date}日，${weekdayName}`);
      this.date = `${year}年${month}月${date}日   ${weekdayName}`;
    },
    nextSlide() {
      this.currentIndex++;
      if (this.currentIndex >= this.tenList.length) {
        this.currentIndex = 0;
      }
    },
    startCarousel() {
      this.interval = setInterval(this.nextSlide, 3000);
    },
    stopCarousel() {
      clearInterval(this.interval);
    },

    doSearch() {},
  },
  beforeDestroy() {
    this.stopCarousel();
  },
};
</script>

<style scoped lang="scss">
.container {
  width: 1120px;
  margin: 0 auto;
  background: #fff;
  position: relative;
}
.top-tips {
  height: 24px;
  margin: 0 12px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .left {
    display: flex;
    align-items: center;

    img {
      margin-top: 2px;
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }
  }
  .right {
    display: flex;
    input {
      width: 160px;
      height: 24px;
      border-radius: 4px 0px 0px 4px;
      border: 1px solid #2b56ac;
    }
    .button {
      width: 24px;
      height: 28px;
      background: #2b56ac;
      border-radius: 0px 4px 4px 0px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 11px;
        height: 12px;
      }
    }
  }
}
.indicator {
  color: #fff;
}
.top {
  width: 1120px;
  height: 277px;
  margin: 0 auto;

  img {
    width: 1120px;
    height: 277px;
  }
}

.banner {
  display: flex;
  width: 1120px;
  height: 120px;
  margin: 12px 0;

  .left-text {
    padding-top: 20px;
    text-orientation: upright;
    font-size: 16px;
    line-height: 20px;
    font-weight: 600;
    color: #fff;
    text-align: center;
    width: 30px;
    background: linear-gradient(to bottom, #3364c5, #1e4188);
  }

  img {
    width: 1090px;
    height: 120px;
  }
}

.date {
  width: 1120px;
  margin: 16px auto;
  font-size: 14px;
  display: flex;
  justify-content: space-around;
  align-items: center;

  .red {
    color: #e71111;
  }

  .linkage-right {
    display: flex;
    justify-content: center;
    align-items: center;

    input {
      width: 110px;
      height: 24px;
      border-radius: 4px 0px 0px 4px;
      border: 1px solid #2b56ac;
    }

    .no-outline-input {
      outline: none;
    }

    .no-outline-input:focus {
      border-color: #2b56ac;
    }

    .button {
      width: 24px;
      height: 28px;
      background: #2b56ac;
      border-radius: 0px 4px 4px 0px;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 11px;
        height: 12px;
      }
    }
  }
}

.custom-list {
  list-style-type: none;
  padding: 0 12px;
}
.warp {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.warp2 {
  display: flex;
  flex-direction: column;
  // justify-content: space-between;
  // align-items: center;
  // flex-wrap: wrap;
  gap: 10px;
}
.custom-list-item {
  flex: 1 0 46%;
  // max-width: 46%;
}
.custom-list li {
  position: relative;
  padding-left: 18px;
  // margin: 10px 0;
}

.custom-list li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 4px;
  background-color: #c1c5cd;
  border-radius: 50%;
}

.li-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;

  span {
    display: inline-block;
    width: 40px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    background: #ffdfdf;
    border-radius: 4px;
    font-size: 10px;
    color: #cc0000;
    // margin-left: 10px;
  }
}

.custom-link {
  color: inherit;
  text-decoration: none;
}

.content {
  width: 100%;
  margin: 0 auto;
  // display: flex;
  // justify-content: flex-start;
  padding-top: 12px;

  .content-left-top {
    width: 98%;
    padding: 0 12px;
    height: 332px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  .swiper {
    width: 500px;
    height: 243px;

    .carousel {
      position: relative;
      width: 100%;
      height: 307px;
      overflow: hidden;
    }

    .carousel-image img {
      width: 100%;
      height: 307px;
    }

    .indicators {
      position: absolute;
      right: 10px;
      bottom: 10px;
      display: flex;
    }

    .indicators span {
      display: inline-block;
      width: 17px;
      height: 17px;
      margin: 0 5px;
      background: #9a8880;
      text-align: center;
      line-height: 17px;
      cursor: pointer;
    }

    .indicators span.active {
      background: #e4730d;
    }
  }

  .title {
    width: 100%;
    height: 22px;
    text-align: center;
    background: #5f5f5f;
    color: #fff;
  }

  .sec-right {
    width: 584px;
    height: 255px;
    // margin-left: 12px;

    .important-news-text {
      width: 380px;
      text-align: center;
      margin-top: 10px;
    }
  }

  .sort {
    width: 1112px;
    height: 800px;
    padding: 12px 4px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    .political-education {
      width: 542px;
      height: 260px;
      border: 1px solid #eee;
    }
    .small-title {
      font-weight: bold;
      font-size: 14px;
      display: flex;
      line-height: 10px;
      margin: 14px;
      p {
        margin: 0;
        margin-right: 12px;
      }
    }
  }

  .sec-right-title {
    width: 100%;
    height: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
  }

  .more-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    right: 12px;
    bottom: 6px;
    color: #2e5bb6;
    font-size: 12px;
    cursor: pointer;
  }

  // .more {
  //     // margin-right: -2px;
  // }

  .blue-rect {
    width: 2px;
    height: 30px;
    background-color: #2851a4;
  }

  .tag {
    width: 100%;
    position: relative;

    img {
      width: 100%;
      height: 30px;
      margin-top: 3px;
    }

    span {
      font-weight: bold;
      font-size: 16px;
      color: #ffffff;
      // width: 64px;
      height: 24px;
      top: 6px;
      left: 16px;
      position: absolute;
    }
  }

  .long-tag {
    img {
      width: 772px;
    }
  }

  .important-news-text {
    font-weight: bold;
    font-size: 14px;
    color: #e71111;
  }

  .content-left-sec {
    width: 98%;
    padding: 0 12px;
    margin-top: 12px;
    height: 254px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  .content-left-sec-left {
    height: 100%;
    width: 100%;
  }

  .thr {
    width: 772px;
  }

  .content-left-thr {
    width: 772px;
    height: 222px;
  }

  .my-li {
    margin: 8px 0;
  }
  .column {
    width: 76%;
    justify-content: space-between;
    min-height: 254px;
    display: flex;
    flex-direction: column;
    border: 1px solid #eee;
  }
  .content-left-thr-content {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .content-left-right {
    margin-left: 14px;
  }

  .content-left-thr-left {
    width: 361px;
    height: 200px;

    .row {
      display: flex;
      justify-content: center;
      align-items: flex-start;
    }

    .row-right {
      width: 301px;
      margin-left: 8px;
    }

    img {
      margin-top: 6px;
      width: 64px;
      height: 24px;
    }
  }

  .content-left-four {
    width: 772px;
    height: 164px;
    margin-top: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .mar-bot {
    margin-bottom: 7px;
  }

  .content-right-top {
    width: 26%;
    height: 255px;
    margin-left: 12px;

    .top-text {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }

    .title {
      width: 104px;
      height: 30px;
      font-weight: bold;
      font-size: 16px;
      color: #ffffff;
      text-align: center;
      line-height: 30px;
      background: linear-gradient(to bottom, #3364c5, #1e4188);
    }

    .blue {
      font-weight: bold;
      font-size: 16px;
      color: #2b56ac;
      margin-left: 20px;
    }
  }

  .content-right-sec {
    width: 26%;
    height: 100%;
    border: 1px solid #eee;
    // height: 384px;
  }

  .right-tab {
    width: 100%;
    height: 30px;
    color: #ffffff;
    padding-right: 12px;
    background: #f5f5f5;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
  }

  .work-box {
    width: 248px;
    height: 151px;
    margin-left: 12px;
  }

  .work {
    width: 228px;
    height: 26px;
    font-size: 14px;
    text-align: center;
    line-height: 26px;
    color: #333333;
    margin: 10px 0;
    border: 0.5px dashed #dadada;
    background: linear-gradient(to bottom, #ffffff, #eeeeee);
  }

  .content-right-five {
    width: 248px;
    height: 176px;
  }

  .right-text {
    width: 92px;
    height: 30px;
    line-height: 30px;
    padding-left: 12px;
    background: linear-gradient(to bottom right, #628fe8, #214690);

    font-weight: bold;
    font-size: 16px;
  }

  .right-more {
    color: #2e5bb6;
    font-size: 12px;
    cursor: pointer;
  }
}

.swiper-img {
  width: 100%;
  min-height: 160px;
  margin: 0 auto;
  margin-top: 16px;

  .carousel-inner img {
    width: 210px;
    height: 140px;
    margin: 0 10px;
  }
}
.brx {
  width: 100%;
  display: flex;
  justify-content: center;
}
.xian {
  width: 100%;
  height: 2px;
  background: #2b56ac;
}
.bottom-btn {
  width: 1120px;
  height: 154px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  align-items: center;

  .btn {
    width: 96px;
    height: 110px;
    background: #ffffff;
    box-shadow: 2px 2px 12px 1px rgba(153, 153, 153, 0.24);
    border-radius: 16px 16px 16px 16px;
    display: flex;
    justify-content: center;
    align-items: center;

    .btn-box {
      text-align: center;
    }

    img {
      width: 40px;
      height: 30px;
    }

    .btn-text {
      margin-top: 5px;
      font-size: 14px;
      color: #333333;
    }
  }
}

.is-show {
  width: 100%;
  height: 72px;
  border: 1px solid #2e5bb6;
  padding: 14px 0 0 14px;
  box-sizing: border-box;
  margin-top: -72px;
  margin-bottom: -10px;
  position: relative;
  background: #fff;
  z-index: 2;
  margin: 0 auto;

  span {
    color: #2e5bb6;
    margin-right: 28px;
  }
}

.is-show-img {
  cursor: pointer;
  width: 100%;
  height: 4px;
  margin: 0 auto;

  img {
    width: 100%;
    height: 4px;
  }
}

.linkage {
  width: 100%;
  height: 70px;
  display: flex;
  // justify-content: space-between;
  align-items: center;
  padding: 0 40px;
  margin: 0 auto;
  box-sizing: border-box;

  .linkage-left {
    width: 730px;
    display: flex;
    // justify-content: center;
    // justify-content: space-between;
    align-items: center;

    .linkage-box {
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 23px;
        height: 20px;
        margin-right: 16px;
      }
    }
  }

  .linkage-text {
    font-weight: bold;
    font-size: 16px;
    color: #2b56ac;
    margin-right: 60px;
  }
}

.bottom-info {
  width: 1120px;
  height: 100px;
  // background: #0E67AB;
  font-size: 14px;
  color: #333333;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;

  .bottom-box div {
    margin: 6px 0;
    text-align: center;
  }
}
.popup-box {
  position: absolute;
  bottom: 70px;
  // left: -112px;
  width: 100%;
  border-top: #0e67ab solid 2px;
  background-color: #fff;
  ul {
    width: 1120px;
    flex-wrap: wrap;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .li {
    width: 22%;
    margin-bottom: 10px;
    margin-left: 10px;
  }
}
.actColor {
  color: #2e5bb6;
}
.hover-underline {
  cursor: pointer; /* 鼠标悬停时显示手形光标 */
}

.hover-underline:hover {
  text-decoration: underline; /* 悬停时添加下划线 */
}
</style>
